import React, { useState } from 'react';
import PropTypes from 'prop-types';

// A single pose tile (class-based styles live in StoreGallery's <style> block
// so we get real :hover states). The default background shows through the
// transparent pose cutout; a ♥ toggles favorites.
const PoseCard = ({
  pose, backgroundUrl, favorite, onToggleFavorite, onSelect,
}) => {
  if (!pose.ready) {
    return (
      <div className="sg-tile sg-tile--processing">
        <div className="sg-shimmer" />
        <span className="sg-processing">Processing…</span>
      </div>
    );
  }

  const label = pose.number != null ? `Pose ${pose.number}` : 'Photo';
  const imgStyle = backgroundUrl ? { backgroundImage: `url(${backgroundUrl})` } : undefined;
  const [loaded, setLoaded] = useState(false);

  return (
    <div className="sg-tile">
      <button type="button" className="sg-tile-btn" onClick={onSelect} aria-label={`View ${label}`}>
        <img
          src={pose.watermark_url}
          alt={label}
          loading="lazy"
          className={`sg-img${loaded ? ' is-loaded' : ''}`}
          style={imgStyle}
          onLoad={() => setLoaded(true)}
        />
        <span className="sg-hint">View &amp; shop</span>
      </button>
      <button
        type="button"
        className={`sg-fav${favorite ? ' sg-fav--on' : ''}`}
        aria-label={favorite ? 'Remove from favorites' : 'Add to favorites'}
        aria-pressed={favorite}
        onClick={() => onToggleFavorite(pose.id)}
      >
        {favorite ? '♥' : '♡'}
      </button>
    </div>
  );
};

PoseCard.propTypes = {
  pose: PropTypes.shape({
    id: PropTypes.number,
    number: PropTypes.number,
    ready: PropTypes.bool,
    watermark_url: PropTypes.string,
  }).isRequired,
  backgroundUrl: PropTypes.string,
  favorite: PropTypes.bool,
  onToggleFavorite: PropTypes.func.isRequired,
  onSelect: PropTypes.func.isRequired,
};

PoseCard.defaultProps = {
  backgroundUrl: null,
  favorite: false,
};

export default PoseCard;
